// extracted by mini-css-extract-plugin
module.exports = {"button":"HouseAcceptanceNotice_button__2_Kpr"};